import { gspx } from '@rsos/gainsight';

export const trackTextTo911CardClick = irpVersion => {
  gspx.trackCustomEvent('Tools Launcher', {
    irpVersion,
    name: 'AGENT511 Click on Reply to Text',
    Category: 'third party',
    'Launched date': new Date(),
  });
};

export const trackTextTo911FormClick = (irpVersion, doesCallExistInQueue) => {
  const NEW_CHAT =
    'AGENT511 Click on Launch Chat (Initiate Chat w/ New Phone Number)';
  const TEXTBACK =
    'AGENT511 Click on Launch Chat (Textback Existing Phone Number)';
  const eventName = doesCallExistInQueue ? TEXTBACK : NEW_CHAT;

  gspx.trackCustomEvent('Tools Launcher', {
    irpVersion,
    name: eventName,
    Category: 'third party',
    'Launched date': new Date(),
  });
};
